import React, { useContext, useEffect } from 'react'
import { contextData } from '../../App'
import WeAre from "../../components/weComponent/WeAre";


function AboutUsPage() {

  const {isScrolled,setIsScrolled} = useContext(contextData);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsScrolled(true)
    return () => {
      setIsScrolled(false)
    }
  },[])

  return (
    <div className=''>
        <WeAre />
    </div>
  )
}

export default AboutUsPage
